import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../core/config';

@Injectable()
export class UploadAdjustmentFileService {
   constructor(
      private http: HttpClient,
      private configService: ConfigService
   ) {
   }

      submitUploadAdjustmentForm(params, files) {
      return new Promise((resolve, reject) => {
         const formData: any = new FormData();
         const xhr = new XMLHttpRequest();
         formData.append('note', params.note);
         formData.append('selectedMonthYear', params.selectedMonthYear);
         for (let loopIndex = 0; loopIndex < files.length; loopIndex++) {
            formData.append('filetoupload', files[loopIndex], files[loopIndex].name);
         }
         xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
               if (xhr.status === 200) {
                  resolve(JSON.parse(xhr.response));
               } else {
                  reject(xhr.response);
               }
            }
         }
         xhr.open('POST', `${this.configService.apiUrl}/uploadprocess/uploadadjustmentfile`, true);
         const token = localStorage.getItem('accessToken');
         if (token) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
         }
         xhr.send(formData);
      });
   }

   getadjustmentfilelist(selectedMonthYear): Observable<any> {
      return this.http.post(`${this.configService.apiUrl}/uploadprocess/getadjustmentfilelist`, { selectedMonthYear });
   }

   
   processAdjustmentMapValues(fId): Observable<any> {
      return this.http.post(`${this.configService.apiUrl}/uploadprocess/processAdjustmentMapValues`, { fId: fId });
   }

   storeMappedAdjustmentValues(params): Observable<any> {
      return this.http.post(`${this.configService.apiUrl}/uploadprocess/storeMappedAdjustmentValues`, params);
   }

   getAdjustmentMasterDropdownsData(filter): Observable<any> {
      return this.http.post(`${this.configService.apiUrl}/uploadprocess/getAdjustmentMasterDropdownsData`, { filter: filter });
   }
   
      deleteAdjustmentUploadedFileRecordCon(params): Observable<any> {
      return this.http.post(`${this.configService.apiUrl}/uploadprocess/deleteAdjustmentUploadedFileRecord`, params);
   }

   getUploadedAdjustmentFile(id): Observable<Blob> {
      const token = localStorage.getItem('accessToken');

      return this.http.get(`${this.configService.apiUrl}/uploadprocess/getUploadedAdjustmentFile/${id}`,
         {
            headers: {
              Authorization: `Bearer ${token}`
            },
            responseType: 'blob'
         }
      );
   }

   downloadAdjustmentTemplate(): Observable<Blob> {
     const token = localStorage.getItem('accessToken');

      return this.http.get(`${this.configService.apiUrl}/uploadprocess/downloadAdjustmentTemplate`,
         {
            headers: {
              Authorization: `Bearer ${token}`
            },
            responseType: 'blob'
         }
      );
   }
 
}
